import React from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

//Single and Doubles TteScoreboard
import TteScoreboard from "components/sports/tte/views/TteScoreboard";
//Teams TteScoreboard
import TteScoreboardTeams from "components/sports/tte/views/TteScoreboardTeams";
//Team Statistics
import TteTeamStats from 'components/sports/tte/views/TteTeamStats'
//Players Statistics
import TtePlayerStats from "components/sports/tte/views/TtePlayerStats";

import Referees from 'components/general/Referees'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import { filterArray } from 'helpers/utils';
import { getEvent } from "helpers/rsc"
import ExpandableData from "components/sports/tte/views/ExpandableData";
import SportCode from "components/common/SportCode";
import { isFinishedStatus } from "helpers/status";
import Label from "components/general/Label";
import Status from 'components/presentation/Status';

const TteContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    //datos para el marcador y estadisticas
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultRSC_H2H,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    let teamMatches = []
    let matches = filterArray(data?.results?.extendedInfos, { ei_code: ['MATCH'] })
    if (matches.length > 0) {
        matches?.forEach(m => {
            teamMatches.push(m.ei_value)
        })
    }
    let queryArray = [];
    teamMatches?.forEach((unit) => {

        queryArray.push({
            queryKey: ['resultsDataH2H', mirs_competition, unit, mirs_language],
            queryFn: getResultRSC_H2H,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        })
    });

    let resultsData = useQueries(queryArray);
    const isLoadingTeams = resultsData.some(result => result.isLoading)
    const isErrorTeams = resultsData.some(result => result.isError)

    const resultStatus = data?.results?.status?.code;
    let bodyMiddle
    let score

    if (data?.results) {
        bodyMiddle = <TteScoreboard data={data} status={resultStatus} mirs_discipline={mirs_discipline} />
    }
    let location = data?.results?.schedule?.location?.shortDescription;
    let round = data?.results?.eventUnit?.shortDescription;
    score = <ScoreHorizontal
        data={data}
        scoreHeader={{
            left: <>{round} - {location}</>
        }}
        scoreBody={{
            top: <></>,
            middle: <>{bodyMiddle}</>
        }}
    />

    if (getEvent(mirs_rsc) === 'TEAM--------------') {
        score = <ScoreHorizontal
            key="score--1"
            data={data}
            scoreHeader={{
                left: <>{round} - {location}</>
            }}
        />
    }

    if (isError || isErrorTeams) { return <NotAvailable />; }
    if (isLoading || isLoadingTeams) { return <Loader />; }


    if (isFinishedStatus(resultStatus))
        resultsData = resultsData.filter(res => res?.data?.results)

    return (
        <>
            {getEvent(mirs_rsc) === 'TEAM--------------'
                ? <>
                    {data?.results ? (
                        <>
                            <PageHeader data={data} />
                            <div className='mirs-page-container'>
                            {score}
                            {resultsData[0]?.data?.results
                                ? <ExpandableData  key="expandable--1" data={data} results={resultsData} resultStatus={resultStatus} />
                                : <div  key="button--1" className="d-flex justify-content-end"><button disabled><Label data={'HeaderTeamMatchStats'} sport={'TTE'} /></button></div>
                            }
                            {resultsData?.map((m, index) => {
                                return <><ScoreHorizontal
                                    key={`score-${index}`}
                                    data={m?.data}
                                    scoreHeader={{
                                        left: <>
                                            <span className="fw-bold">{matches[index]?.ei_code} {matches[index]?.ei_pos}</span>&nbsp;
                                            {(index === 3 || index === 4) && !m?.data?.results
                                                ? <><SportCode discipline={mirs_discipline} entity={'@Status'} code={'IF_REQ'} /> </>
                                                : <></>
                                            }
                                        </>
                                    }}
                                    scoreBody={{
                                        top: <></>,
                                        middle: <TteScoreboardTeams data={m?.data} status={m?.data?.results?.status?.code} mirs_discipline={mirs_discipline} />
                                    }}
                                />
                                    {m?.data?.results
                                        ? <><ExpandableData key={`expandable-${index}`} data={m?.data} resultStatus={m?.data?.results?.status?.code} /></>
                                        : <><button key={`button-${index}`} disabled><Label data={'HeaderMatchStatistics'} /></button></>
                                    }
                                </>
                            })}

                            {data?.results?.officials &&
                                <Referees data={data?.results?.officials} showHeader={true} />
                            }
                            </div>

                        </>
                    ) : (
                        <NotAvailable />
                    )
                    }</>
                : <>
                    {data?.results ? (
                        <>
                            <PageHeader data={data} />
                            <div className='mirs-page-container'>
                            {score}

                            {/* Match / Games Statistics */}
                            <TteTeamStats data={data} isTeamAndMain={false}/>

                            {/* Player Statistics */}
                            <TtePlayerStats data={data} isTeamAndMain={false} isTeam={(data?.results?.items?.find(x => x !== undefined)?.statsItems !== undefined)}/>

                            {data?.results?.officials &&
                                <Referees data={data?.results?.officials} showHeader={true} />
                            }
                            </div>

                        </>
                    ) : (
                        <NotAvailable />
                    )
                    }</>
            }

        </>
    )

}

export default TteContext;